// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-detail-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: calc(100vh - 100px);
    padding-bottom: 100px;
    position: relative;
}

.video-detail-content {
    width: 80%;
    max-width: 1200px;
    text-align: center;
}

.video-detail-content h1 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 55px;
    text-align: center;
    color: #047da2;
    margin-top: 20px;
    margin-bottom: 30px;
}


.video-description {
    width: 45%;
    text-align: justify;
    margin-right: 25px;
}

.video-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.video-detail-content p {
    font-size: 20px;
    margin-bottom: 30px;
}

.video-iframe-container {
    width: 100%;
    margin-bottom: 30px;
}

.video-iframe-container iframe {
    width: 100%;
    aspect-ratio: 16 / 9;
}

.video-navigation {
    justify-content: space-between;
    margin-top: 20px;
}

.video-navigation a {
    text-decoration: none;
    color: inherit;
    display: block;
}

.prev-video,
.next-video {
    text-align: center;
    margin-top: 30px;
}

.prev-video p,
.next-video p {
    font-weight: bold;
    margin-bottom: 5px;
    color: #ffffff;
    font-size: 15px;
    background-color: #047da2;
    padding: 5px 20px;
    border-radius: 32px;
    text-align: center;
    display: inline-block;
}

.prev-video h4,
.next-video h4 {
    font-size: 15px;    
}

.loading-message,
.error-message,
.not-found-message {
    text-align: center;
    margin-top: 50px;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
}

.video-navigation-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 30px;
}

.video-navigation-mobile .prev-video,
.video-navigation-mobile .next-video {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}

.video-navigation-mobile .prev-video p,
.video-navigation-mobile .next-video p {
    font-size: 15px;
    color: #ffffff;
    margin-bottom: 5px;
}

.video-navigation-mobile .prev-video h4,
.video-navigation-mobile .next-video h4 {
    font-size: 15px;
}


/* Responsive */
@media (max-width: 768px) {
    .video-info {
        flex-direction: column;
    }

    .video-description,
    .video-iframe-container {
        width: 100%;
    }

    .video-iframe-container {
        margin-bottom: 0;
    }

    .video-navigation-mobile {
        margin-top: 0;
    }

    .video-navigation-mobile a {
        text-decoration: none;
        color: inherit;
        display: block;
    }

    .video-detail-content h1 {
        font-size: 25px;
    }

    /* Oculta la navegación original en móvil */
    .video-navigation {
        display: none;
    }

    .prev-video,
    .next-video {
        width: 100%;
        margin-top: 20px;
        margin-bottom: 10px;
        text-align: center;
    }

    .prev-video p, .next-video p {
        font-size: 15px;
    }

    .prev-video h4, .next-video h4 {
        font-size: 15px;
    }

    .video-description {
        font-size: 1em;
    }

    .video-detail-content p {
        font-size: 12px;
    }

    .video-navigation-mobile .prev-video p,
    .video-navigation-mobile .next-video p {
        font-size: 12px;
    }

    .video-navigation-mobile .prev-video h4,
    .video-navigation-mobile .next-video h4 {
        font-size: 12px;
    }
}

/* Estilos para pantallas más grandes (revertir comportamiento de video-navigation-mobile) */
@media (min-width: 769px) {
    .video-navigation-mobile {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Trainings/VideoDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;;AAGA,eAAe;AACf;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA,2CAA2C;IAC3C;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA,4FAA4F;AAC5F;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".video-detail-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: calc(100vh - 100px);\n    padding-bottom: 100px;\n    position: relative;\n}\n\n.video-detail-content {\n    width: 80%;\n    max-width: 1200px;\n    text-align: center;\n}\n\n.video-detail-content h1 {\n    font-family: 'Roboto', sans-serif;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 55px;\n    text-align: center;\n    color: #047da2;\n    margin-top: 20px;\n    margin-bottom: 30px;\n}\n\n\n.video-description {\n    width: 45%;\n    text-align: justify;\n    margin-right: 25px;\n}\n\n.video-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.video-detail-content p {\n    font-size: 20px;\n    margin-bottom: 30px;\n}\n\n.video-iframe-container {\n    width: 100%;\n    margin-bottom: 30px;\n}\n\n.video-iframe-container iframe {\n    width: 100%;\n    aspect-ratio: 16 / 9;\n}\n\n.video-navigation {\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.video-navigation a {\n    text-decoration: none;\n    color: inherit;\n    display: block;\n}\n\n.prev-video,\n.next-video {\n    text-align: center;\n    margin-top: 30px;\n}\n\n.prev-video p,\n.next-video p {\n    font-weight: bold;\n    margin-bottom: 5px;\n    color: #ffffff;\n    font-size: 15px;\n    background-color: #047da2;\n    padding: 5px 20px;\n    border-radius: 32px;\n    text-align: center;\n    display: inline-block;\n}\n\n.prev-video h4,\n.next-video h4 {\n    font-size: 15px;    \n}\n\n.loading-message,\n.error-message,\n.not-found-message {\n    text-align: center;\n    margin-top: 50px;\n}\n\n.loading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 500px;\n}\n\n.video-navigation-mobile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-top: 30px;\n}\n\n.video-navigation-mobile .prev-video,\n.video-navigation-mobile .next-video {\n    width: 100%;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\n.video-navigation-mobile .prev-video p,\n.video-navigation-mobile .next-video p {\n    font-size: 15px;\n    color: #ffffff;\n    margin-bottom: 5px;\n}\n\n.video-navigation-mobile .prev-video h4,\n.video-navigation-mobile .next-video h4 {\n    font-size: 15px;\n}\n\n\n/* Responsive */\n@media (max-width: 768px) {\n    .video-info {\n        flex-direction: column;\n    }\n\n    .video-description,\n    .video-iframe-container {\n        width: 100%;\n    }\n\n    .video-iframe-container {\n        margin-bottom: 0;\n    }\n\n    .video-navigation-mobile {\n        margin-top: 0;\n    }\n\n    .video-navigation-mobile a {\n        text-decoration: none;\n        color: inherit;\n        display: block;\n    }\n\n    .video-detail-content h1 {\n        font-size: 25px;\n    }\n\n    /* Oculta la navegación original en móvil */\n    .video-navigation {\n        display: none;\n    }\n\n    .prev-video,\n    .next-video {\n        width: 100%;\n        margin-top: 20px;\n        margin-bottom: 10px;\n        text-align: center;\n    }\n\n    .prev-video p, .next-video p {\n        font-size: 15px;\n    }\n\n    .prev-video h4, .next-video h4 {\n        font-size: 15px;\n    }\n\n    .video-description {\n        font-size: 1em;\n    }\n\n    .video-detail-content p {\n        font-size: 12px;\n    }\n\n    .video-navigation-mobile .prev-video p,\n    .video-navigation-mobile .next-video p {\n        font-size: 12px;\n    }\n\n    .video-navigation-mobile .prev-video h4,\n    .video-navigation-mobile .next-video h4 {\n        font-size: 12px;\n    }\n}\n\n/* Estilos para pantallas más grandes (revertir comportamiento de video-navigation-mobile) */\n@media (min-width: 769px) {\n    .video-navigation-mobile {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
